"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M3 19h18v-6H3zm0-8h18V9H3zm0-6v2h18V5z"
}), 'HorizontalSplit');